module.exports = __webpack_public_path__ + "img/sleeve opening.f5019b52.png";